import React, { useCallback, useEffect, useState } from "react";
import { post } from "../server/api.js";
import Translator from "./translator";
import "../../css/profile-page.css";

function ProfileForgotPasswordPanel({
  language,
  idZec,
  initialUsername = "",
  setAlert,
  showOverlay,
  hideOverlay,
  onBack,
  onForgotSuccess,
}) {
  const TEXTS = Translator(language, "TXT_PROFILE_PAGE");
  const [username, setUsername] = useState(initialUsername || "");

  useEffect(() => {
    setUsername(initialUsername || "");
  }, [initialUsername]);

  const requestForgotPassword = useCallback(() => {
    const u = (username || "").trim();
    if (!u) {
      setAlert(TEXTS.error0, "danger");
      return;
    }

    showOverlay("PROFILE_FORGOT_PASSWORD");

    post("/" + idZec + "/Utilisateur/ForgotPassword", JSON.stringify({ username: u }), {
      convertToJson: false,
      acceptLanguage: language,
    })
      .then((result) => {
        if (result.status !== 200)
          throw new Error(TEXTS.forgotErrorGeneric);
        return result.json();
      })
      .then((body) => {
        if (!body || !body.success)
          throw new Error(TEXTS.forgotErrorGeneric);
        setAlert(TEXTS.forgotSuccess, "success");
        if (onForgotSuccess)
          onForgotSuccess();
      })
      .catch((e) => {
        if (e.name !== "AbortError")
          setAlert(e.message, "danger");
      })
      .finally(() => {
        hideOverlay("PROFILE_FORGOT_PASSWORD");
      });
  }, [username, idZec, language, TEXTS, setAlert, showOverlay, hideOverlay, onForgotSuccess]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        requestForgotPassword();
      }
    },
    [requestForgotPassword]
  );

  return (
    <div id="profile-page">
      <div className="display-inline-block">
        <div className="profile-div profile-label-wrapper-title profile-signup-form-title">
          <span className="profile-span">{TEXTS.motDePasseOublie}</span>
        </div>
        <div className="profile-div">
          <span className="profile-span" style={{ display: "block", textAlign: "left" }}>
            {TEXTS.textForgotIntro}
          </span>
        </div>
        <div>
          <div className="profile-label-wrapper">
            <span className="profile-span">{TEXTS.usename}</span>
          </div>
          <div className="input-container">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={onKeyDown}
              className="profile-input"
            />
          </div>
        </div>
        <div className="profile-div">
          <div className="profile-div btn-login clickable" onClick={() => requestForgotPassword()}>
            <span className="profile-span">{TEXTS.btnForgotSubmit}</span>
          </div>
        </div>
        <div className="profile-div" style={{ textAlign: "center" }}>
          <span className="clickable primary-color message profile-span" onClick={() => onBack && onBack()}>
            {TEXTS.btnForgotBack}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProfileForgotPasswordPanel;
